import React from 'react';

import { Container, ContainerDonuts } from './DonutInfo.styles';
import { ProgressBarInfo } from './components/ProgressBarInfo';

export type ProgressCardProps = {
	progressColor: string;
	percent: number;
	total?: number;
	filled?: number;
	labelText?: string;
	description?: string;
	title?: string;
};

export interface DonutInfoProps {
	answerReffered: {
		answered: any;
		percent: any;
		total: any;
		color: any;
	};
	answers: {
		answered: any;
		percent: any;
		total: any;
		color: any;
	};
	requireAttention: {
		answered: any;
		percent: any;
		total: any;
		color: any;
	};
	risks: any;
	risk: any;
	position: number;
}

export const DonutInfo = ({
	answerReffered,
	answers,
	requireAttention,
	risks,
	risk,
	position,
}: DonutInfoProps) => {
	const subDescriptionText = risks.length
		? 'Se requiere al menos el 80%'
		: 'Se requiere completar el 100% de la plantilla';

	const isTheFirstForm = position === 0;

	return (
		<Container>
			<ContainerDonuts>
				<ProgressBarInfo
					total={answers?.total}
					answered={answers?.answered}
					percent={answers?.percent}
					color="#8FEA57"
					description="Evaluaciones completadas"
				/>
				{isTheFirstForm && (
					<>
						<ProgressBarInfo
							total={requireAttention?.total}
							answered={requireAttention?.answered}
							percent={requireAttention?.percent}
							color="#FF3773"
							description="Requieren atención"
						/>
						<ProgressBarInfo
							total={answerReffered?.total}
							answered={answerReffered?.answered}
							percent={answerReffered?.percent}
							color="#1AB0E6"
							description="Referidas hasta ahora"
						/>
					</>
				)}
				{!isTheFirstForm && (
					<ProgressBarInfo
						labelText={risk.name}
						title={risk.name}
						percent={100}
						color={risk?.color}
						description="Nível de riesgo general"
					/>
				)}
			</ContainerDonuts>
			<p>{subDescriptionText}</p>
		</Container>
	);
};
